import { Pipe, PipeTransform } from '@angular/core';
import * as dayjs from "dayjs";

@Pipe({
  name: 'chatDate'
})
export class ChatDatePipe implements PipeTransform {

  transform(createdAtDateSeconds: number) : string {
    createdAtDateSeconds = createdAtDateSeconds * 1000;
    // oggi ora
    // ieri ora
    // entro 6 giorni lun/mar/... ora
    // oltre dd/M ora
    // anni precedenti al corrente: include anche l'anno

    const today = dayjs();
    const yesterday = dayjs().subtract(1, 'day');
    const lastWeek = dayjs().subtract(6, 'days');
    const currentYear = dayjs().year();

    const day = dayjs(createdAtDateSeconds);
    const weekday = day.toDate().toLocaleString('it-IT', {weekday: 'long'}); // lun ...dom
    // const time = day.format('HH:mm');

    if(day.isSame(today, 'day')) {
      return `oggi`;
    } else if(day.isSame(yesterday, 'day')) {
      return `ieri`;
    } else if(day.isAfter(lastWeek, 'day')) {
      return weekday;
    } else if (day.year() < currentYear) {
      return day.format('DD/MM/YY');
    } else {
      return day.format('DD/MM');
    }
  }
}
